export const FETCH_ALL_AREAS = 'FETCH_ALL_AREAS';
export const RESET_ALL_AREAS = 'REASET_ALL_AREAS';
export const SET_AREA = 'SET_AREA';
export const RESET_AREA = 'RESET_AREA';
export const SET_ASSIGNED_ROOMS = 'SET_ASSIGNED_ROOMS';
